import React, { useContext, useEffect, useRef } from "react";
import StateContext from "../../context/state";
import styles from "./PaginationServices.module.scss";
import PathContext from "../../context/path";
const PaginationServices = () => {
  const path = useContext(PathContext);
  const stateApp = useContext(StateContext);
  const { stage, allStages, updateStage, transition, updateTransition, isMobile } = stateApp;

  const refSection = useRef([]);
  const handleClick = (e, index) => {
    e.stopPropagation();
    if (!transition) {
      updateStage(index);
    }
  }

  let dots1 = [];
  let dots2 = [];
  let dots3 = [];
  let dots = <>
    <div className={styles.section} ref={el => refSection.current[0] = el} onClick={(e) => { handleClick(e, 0) }}>
      <div className={styles.section__title}>Начало</div>
      <div className={styles.section__dots}></div>
    </div>
    <div className={styles.section} ref={el => refSection.current[1] = el} onClick={(e) => { handleClick(e, 1) }}>
      <div className={styles.section__title}>Транзитные перевозки</div>
      <div className={styles.section__dots}>
        {dots1}
      </div>
    </div>
    <div className={styles.section} ref={el => refSection.current[2] = el} onClick={(e) => { handleClick(e, 7) }}>
      <div className={styles.section__title}>Перевозки из Китая</div>
      <div className={styles.section__dots}>
        {dots2}
      </div>
    </div>
    <div className={styles.section} ref={el => refSection.current[3] = el} onClick={(e) => { handleClick(e, 13) }}>
      <div className={styles.section__title}>Перевозки в Китай</div>
      <div className={styles.section__dots}>
        {dots3}
      </div>
    </div>
  </>;
  if (allStages !== undefined && allStages > 0 && stage !== undefined) {
    if (!isMobile) {
      for (let i = 0; i < allStages; i++) {
        let item = null
        if (i === stage) {
          item = <div className={`${styles.dot} ${styles.active}`} key={`dot-${i}`}></div>;
        } else {
          item = <div className={styles.dot} key={`dot-${i}`} onClick={(e) => { handleClick(e, i) }}></div>;
        }
        switch (true) {
          case (i > 0 && i < 7):
            dots1.push(item)
            break;
          case (i > 6 && i < 13):
            dots2.push(item)
            break;
          case (i > 12):
            dots3.push(item)
            break;

          default:
            break;
        }
      }
    } else {
      dots = `${stage + 1}/${allStages}`
    }
  }
  useEffect(() => {
    if (isMobile) return;
    const sections = refSection.current;
    sections.forEach(element => {
      element.classList.remove(styles.active);
    });
    switch (true) {
      case (stage === 0):
        sections[0].classList.add(styles.active);
        break;
      case (stage > 0 && stage < 7):
        sections[1].classList.add(styles.active);
        break;
      case (stage > 6 && stage < 13):
        sections[2].classList.add(styles.active);
        break;
      case (stage > 12):
        sections[3].classList.add(styles.active);
        break;

      default:
        break;
    }
  }, [stage, allStages, isMobile]);
  return (
    <>
      <div className={styles.wrap} data-pagination>
        {dots}

      </div>
    </>
  );

}

export default PaginationServices;
